// packages/storefront/src/components/general/WidgetErrorAlert.tsx
import type { ResultError } from '@tourtask/types/result';
import { AlertBox } from '@tourtask/ui/components/AlertBox';
import { OriginNotAllowedAlert } from '@tourtask/storefront/components/general/OriginNotAllowedAlert';
import { showsOriginNotAllowedNotice } from '@tourtask/storefront/components/general/originNotAllowedKeys';
import { useLocalization } from '@tourtask/storefront/hooks/useLocalization';

/**
 * An API failure a widget shows in its place (the chat: in its panel). A page the business has not registered
 * (`CORS.ORIGIN_NOT_ALLOWED`) gets the translated `OriginNotAllowedAlert` once its texts are loaded — the strings
 * route answers any page. Anything else, and that one too while its texts are missing, is said in the API's own
 * words: the message it answered with, in English ("Business not found", "Invalid bizToken").
 */
export function WidgetErrorAlert({ error }: { error: ResultError }) {
	const { getStr } = useLocalization();
	if (showsOriginNotAllowedNotice(error, getStr)) {
		return <OriginNotAllowedAlert />;
	}
	return (
		<AlertBox type="error" mb={0}>
			{error.message}
		</AlertBox>
	);
}
